import { Ref } from "vue";

export const useBannerAlert = () => {
  const showAlert: Ref<Boolean> = ref(false);
  const alertType: Ref<String> = ref("");
  const alertMessage: Ref<String> = ref("");
  const alertId: Ref<String> = ref("");
  const showAlertMessage = (type: String, message: String) => {
    alertType.value = type;
    alertMessage.value = message;
    showAlert.value = true;
    alertId.value = Math.random().toString(36).slice(2);
  };

  const resetAlert = () => {
    showAlert.value = false;
    alertType.value = "";
    alertMessage.value = "";
  };

  const showErrorBannerAlert = () => {
    showAlertMessage("danger", "Es ist ein Fehler aufgetreten");
  };

  return {
    showAlert,
    alertType,
    alertMessage,
    alertId,
    showAlertMessage,
    resetAlert,
    showErrorBannerAlert
  };
};
